import React, { useEffect, useState, useRef } from 'react'
import { decode } from 'html-entities'
import TradeInProduct from './tradeInProduct/TradeInProduct'
import TradeInRequest from './tradeInRequest/TradeInRequest'
import ModalDialog from '../modalDialog/ModalDialog'

function TradeIn (props) {
  const requestDefaultState = { name: '', phone: '', city: '', merchant: '', comment: '' }
  // сформированный товар на обмен
  const [exchangeProduct, setExchangeProduct] = useState(null)
  // сформированный товар на покупку
  const [buyProduct, setBuyProduct] = useState(null)
  // признак показа блока позсказки с ценовым диазоном товаров на обмен
  const [showRangeHint, setShowRangeHint] = useState(false)
  // сформированный товар на обмен
  const [exchangePriceRange, setExchangePriceRange] = useState({ min: 0, max: 0, name: '' })
  // данные по заявке на обмен
  const [tradeinRequestData, setTradeinRequestData] = useState(null)
  // данные формы заявки
  const [requestFormData, setRequestFormData] = useState(requestDefaultState)
  // список свойств группы и выбранных значений товара на обмен
  const [checkedExchangePropValues, setCheckedExchangePropValues] = useState({})
  // список свойств группы и выбранных значений товара на покупку
  const [checkedBuyPropValues, setCheckedBuyPropValues] = useState({})
  // минимальная цена кредитования
  const [minCreditPrice, setMinCreditPrice] = useState(0)
  // сумма к оплате по трейд-ин
  const [priceDiff, setPriceDiff] = useState(0)

  const [buyProductPrice, setBuyProductPrice] = useState(0)

  const [maxCountPaymentsByService, setMaxCountPaymentsByService] = useState(0)

  // состояния для режимов
  const [selectedMode, setSelectedMode] = useState('exchange') // 'sell' или 'exchange'

  // рефы для блоков этапов
  const step1Ref = useRef(null)
  const step2Ref = useRef(null)
  const step3Ref = useRef(null)

  useEffect(() => {
    if (exchangeProduct !== null && showRangeHint)
      setShowRangeHint(false)
  }, [exchangeProduct])

  useEffect(() => {
    if(exchangeProduct !== null && buyProduct !== null) {
      getMinCreditPrice()
    }
  } , [exchangeProduct, buyProduct])

  useEffect(() => {
    if (buyProduct) {
      const isOldPrice = hasOldPriceGroup();
      setBuyProductPrice(isOldPrice ? buyProduct.old_price : buyProduct.price);
    }
  }, [buyProduct]);

  // Устанавливает максимальное количество платежей buyProduct , исходя из ограничений по его разделу
  useEffect(() => {
    if (buyProduct && buyProduct.groups && props.max_count_payments_by_section) {
      const creditTermsKeys = Object.keys(props.max_count_payments_by_section);
      const matchingKey = creditTermsKeys.find(key => buyProduct.groups.includes(parseInt(key, 10)));

      if (matchingKey && props.max_count_payments_by_section[matchingKey]) {
        const creditTermValue = props.max_count_payments_by_section[matchingKey];
        setMaxCountPaymentsByService(Number(creditTermValue.max_payments));
      }
    }
  }, [buyProduct, props.max_count_payments_by_section]);

  useEffect(() => {
    if (exchangeProduct !== null && buyProduct !== null && maxCountPaymentsByService > 0) {
      getMinCreditPrice();
    }
  }, [exchangeProduct, buyProduct, maxCountPaymentsByService]);

  // автоматическая прокрутка при выборе товара
  useEffect(() => {
    let targetRef = null
    let delay = 300

    if (buyProduct && exchangeProduct && selectedMode === 'exchange') {
      // если есть ОБА товара и режим exchange → к step3
      targetRef = step3Ref
    } else if (exchangeProduct && selectedMode === 'sell') {
      // если режим продажи → к step3
      targetRef = step3Ref
    } else if (exchangeProduct && selectedMode === 'exchange') {
      // если только exchange товар → к step2
      targetRef = step2Ref
    }

    if (targetRef) {
      setTimeout(() => scrollToStep(targetRef), delay)
    }
  }, [exchangeProduct, buyProduct, selectedMode])

  function hasOldPriceGroup() {
    if (buyProduct && buyProduct.groups && props.section_settings) {
      // Проверяем каждую группу товара
      return buyProduct.groups.some(group => {
        const settings = props.section_settings[parseInt(group)];
        return settings?.use_old_price === true;
      });
    }

    return false;
  }

  // функция для плавной прокрутки
  const scrollToStep = (stepRef) => {
    if (stepRef.current) {
      stepRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
  }

  function getMinCreditPrice() {
    let result = 0;

    if (buyProduct && exchangeProduct) {
      // получаем настройки раздела для buyProduct
      const sectionSettings = buyProduct.groups
        ? buyProduct.groups.reduce((found, group) => {
          return found || (props.section_settings?.[parseInt(group)] ?? null);
        }, null)
        : null;

      const useOldPrice = sectionSettings?.use_old_price === true;
      const useWarranty = sectionSettings?.use_warranty === true;

      // стоимость гарантии — 33% от базовой цены
      const warrantyPrice = Math.round(buyProduct.price * 0.33);

      let basePrice;
      if (useOldPrice && useWarranty) {
        basePrice = buyProduct.old_price + warrantyPrice;
      } else if (useOldPrice) {
        basePrice = buyProduct.old_price;
      } else if (useWarranty) {
        basePrice = buyProduct.price + warrantyPrice;
      } else {
        basePrice = buyProduct.price;
      }

      let price = Number(basePrice) - (Math.round(Number(exchangeProduct.price) / 100) * 100);
      setPriceDiff(price);

      let itemsList = props.credit_terms;
      itemsList.forEach(item => {
        if(price > item.UF_E && price < item.UF_F) {
          let a = price * (item.UF_L ? item.UF_L : 0) / 100

          // Ограничиваем UF_C максимальным значением maxCountPaymentsByService
          let uf_c = item.UF_C > maxCountPaymentsByService ? maxCountPaymentsByService : item.UF_C

          let k = (uf_c ? uf_c : 0) * (item.UF_K ? item.UF_K : 0)
          let g = price * (item.UF_G ? item.UF_G : 0) / 100
          let m = price * (item.UF_M ? item.UF_M : 0) / 100
          let o = price * (item.UF_O ? item.UF_O : 0) / 100

          let creditPrice = (price + a + k + g + m + o) / (uf_c ? uf_c : item.UF_C)

          if( result === 0 || (creditPrice > 0 && creditPrice < result)) {
            result = creditPrice
          }
        }

      })
    }
    setMinCreditPrice(result)

  }

  function onCloseModal () {
    if (tradeinRequestData.hasOwnProperty('success') && tradeinRequestData.success) {
      setCheckedExchangePropValues({})
      setCheckedBuyPropValues({})
      setRequestFormData(requestDefaultState)
    }

    setTradeinRequestData(null)
  }

  /**
   * при завершении формирования твоара на обмен / покупку сохраняем данные о товаре
   * @param product
   * @param type
   */
  function onProductChecked (product, type) {
    if (type === 'exchange') {
      setExchangeProduct(product)
      setSelectedMode('exchange')
    }
    else if (type === 'buy') setBuyProduct(product)
  }

  function getMessage (code) {
    return props.hasOwnProperty('messages') && props.messages.hasOwnProperty(code) ?
      props.messages[code] : `message ${code} undefined`
  }

  // обработчики кликов на кнопки
  function handleSellClick() {
    setSelectedMode('sell')
    // сбрасываем товар для покупки при выборе продажи
    setBuyProduct(null)
    setCheckedBuyPropValues({})
  }

  function handleExchangeClick() {
    setSelectedMode('exchange')
  }

  const shouldRenderBuyStep = selectedMode === 'exchange' &&
    (exchangeProduct !== null || buyProduct !== null || Object.keys(checkedBuyPropValues).length > 0)

  const standartHint = buyProduct === null || exchangeProduct === null ?
    <></> :
    <>
      <div className="buy-grade-info">
        <div className="flex flex-col gap-2.5">
          <div className="flex items-end">
            <div className="trade-in-product-price">
              <span className="trade-in-discount__title">{getMessage('tradeInProductPrice')}</span>
              <span
                className="trade-in-discount__price">{buyProduct.price_formated} </span>
            </div>
            <div className="pb-[6px]">&ndash;</div>
            <div className="trade-in-discount">
              <span className="trade-in-discount__title">{getMessage('tradeInDiscount')}</span>
              <span
                className="trade-in-discount__price">{new Intl.NumberFormat('ru-RU').format(Math.round(Number(exchangeProduct.price) / 100) * 100)} &#8372;</span>
            </div>
            <div className="pb-[6px]">&#61;</div>
          </div>
          <div className="flex items-end">
            <div className="trade-in-new">
              <span className="trade-in-new__title">{getMessage('tradeInNewPrice')}</span>
              <span className="trade-in-new__price">
                {new Intl.NumberFormat('ru-RU').format(Math.round(buyProduct.price - (Math.round(Number(exchangeProduct.price) / 100) * 100)))} &#8372;
              </span>
            </div>
            {
              priceDiff > props.credit_restriction[0].UF_MIN_PRICE ?
                <>
                  <div className="pb-[6px]">&#8260;</div>

                  <div className="trade-in-credit-price">
                    <span className="trade-in-new__title">{getMessage('tradeInCreditPrice')}</span>
                    <span className="trade-in-new__price">
                      {new Intl.NumberFormat('ru-RU').format(Math.round(minCreditPrice))} &#8372;
                    </span>
                  </div>
                </> :
                <></>
            }
          </div>
        </div>
      </div>
    </>

  const productPriceEstimate = exchangeProduct === null ?
    <></> : getMessage('changeGradeInfo1')

  const additionalDisocunt = exchangeProduct === null ?
    <></> :
    <div className="price-rules-message">
      <b style={{'color': '#000'}}>{getMessage('additionalBenefits1')}</b>
      {getMessage('additionalBenefits2')}
      <br/><br/>
      {getMessage('additionalBenefits3')}
    </div>

  const priceRangeHint = <>
    <div className="change-grade-info">
      {getMessage('price')}&nbsp;
      {decode(exchangePriceRange.name)}
      {getMessage('changeGradeInfo3')}
      {getMessage('from')}
      &nbsp;{new Intl.NumberFormat('ru-RU').format(exchangePriceRange.min)} &#8372;
      &nbsp;{getMessage('to')}&nbsp;
      {new Intl.NumberFormat('ru-RU').format(exchangePriceRange.max)} &#8372;.
      &nbsp;{getMessage('changeGradeInfo4')}
    </div>
  </>

  const priceHigherHint = <div className="change-grade-info"
                               dangerouslySetInnerHTML={{ __html: getMessage('changeGradeInfoHigher') }}/>

  console.log(props)
  return (
    <div className="trade-in-form">
      <div ref={step1Ref} className="trade-in-holder change active">
        <div className="trade-in-head">
          <div className="trade-in-head__title">
            <span className="trade-in__title-circle">1</span>
            <span className="trade-in__title">{getMessage('firstSection')}</span>
          </div>
        </div>
        <div className="trade-in-content">
          <div className="trade-in-change-props">
            <TradeInProduct groups={props.groups.exchange}
                            property_data={props.property_data}
                            getMessage={getMessage}
                            version={props.version}
                            setExchangePriceRange={setExchangePriceRange}
                            checkedPropValues={checkedExchangePropValues}
                            setCheckedPropValues={setCheckedExchangePropValues}
                            type={'exchange'}
                            onProductChecked={onProductChecked}/>
          </div>
          {
            exchangeProduct !== null ?
              <div className="grid grid-cols-1 gap-3 items-center min-1024:grid-cols-2 from-tablet:pr-3">
                <div className="flex items-center gap-5">
                  <img
                    src={exchangeProduct.hasOwnProperty('image_alt') && typeof exchangeProduct.image_alt === 'string' && exchangeProduct.image_alt.length ?
                      exchangeProduct.image_alt : exchangeProduct.image_orig}
                    loading={'eager'}
                    className="w-[180px] !m-0"
                    alt={decode(exchangeProduct.name)}
                    title={decode(exchangeProduct.name)}/>
                  <div className="flex flex-col gap-[10px] desktop:max-w-[190px]">
                    <span className="tex-[#999] text-[11px] font-normal">{getMessage('tradeInYourGadget')}</span>
                    <span className="tex-[#333] text-[14px] font-bold">{exchangeProduct.name}</span>
                  </div>
                </div>

                <div className={`trade-in-buttons grid ${Math.round(Number(exchangeProduct.price_for_sell)) > 0 ? 'grid-cols-2 gap-2' : 'grid-cols-1 gap-y-2'}`}>
                  <div
                    className={`py-[11px] px-[11px] flex flex-col gap-[6px] justify-center rounded-[14px] items-center text-center cursor-pointer border border-solid border-[#6364ff] ${selectedMode === 'exchange' ? 'active' : ''}`}
                    onClick={handleExchangeClick}>
                    <span className="text-[#999999] text-[12px] font-normal">{getMessage('tradeInExchangeBtn')}</span>
                    <span
                      className="text-[#6364ff] text-[16px] font-bold">{new Intl.NumberFormat('ru-RU').format(Math.round(Number(exchangeProduct.price) / 100) * 100)} &#8372; *</span>
                  </div>
                  {
                    Math.round(Number(exchangeProduct.price_for_sell)) > 0 ?
                      <div
                        className={`py-[11px] px-[11px] flex flex-col gap-[6px] justify-center rounded-[14px] items-center text-center cursor-pointer border border-solid border-[#6364ff] ${selectedMode === 'sell' ? 'active' : ''}`}
                        onClick={handleSellClick}>
                        <span className="text-[#999999] text-[12px] font-normal">{getMessage('tradeInSellBtn')}</span>
                        <span
                          className="text-[#6364ff] text-[16px] font-bold">{new Intl.NumberFormat('ru-RU').format(Math.round(Number(exchangeProduct.price_for_sell) / 100) * 100)} &#8372; *</span>
                      </div> :
                      <></>
                  }
                  <div className="col-span-2 w-full text-[11px] text-[#999] font-normal text-center">
                    {productPriceEstimate}
                  </div>
                </div>
              </div> :
              <></>
          }
          {/*{additionalDisocunt}*/}

          {showRangeHint ? priceRangeHint : <></>}
        </div>
      </div>

      {
        shouldRenderBuyStep &&
        <div ref={step2Ref}
             className={`trade-in-holder buy active ${exchangeProduct === null ? 'hidden pointer-events-none' : ''}`}
             aria-hidden={exchangeProduct === null}
             onClick={event => {
               if (exchangeProduct === null) setShowRangeHint(true)
             }}>
          <div className="trade-in-head">
            <div className="trade-in-head__title">
              <span className="trade-in__title-circle">2</span>
              <span className="trade-in__title">{getMessage('secondSection')}</span>
            </div>
            <div className="trade-in-head__descr">{getMessage('secondSectionDescr')}</div>
          </div>
          <div className="trade-in-content">
            <div className="trade-in-change-props">
              <TradeInProduct groups={props.groups.buy}
                              property_data={props.property_data}
                              getMessage={getMessage}
                              version={props.version}
                              checkedPropValues={checkedBuyPropValues}
                              setCheckedPropValues={setCheckedBuyPropValues}
                              type={'buy'}
                              onProductChecked={onProductChecked}/>
            </div>

            {
              buyProduct !== null ?
                <>
                  <div className="grid grid-cols-1 gap-3 items-center min-1024:grid-cols-2 from-tablet:pr-3">
                    <div className="flex items-center gap-5">
                      <img
                        src={buyProduct.hasOwnProperty('image_alt') && typeof buyProduct.image_alt === 'string' && buyProduct.image_alt.length ?
                          buyProduct.image_alt : buyProduct.image_orig}
                        className="w-[180px] !m-0"
                        alt={decode(buyProduct.name)}
                        title={decode(buyProduct.name)}/>
                      <div className="flex flex-col gap-[10px] desktop:max-w-[190px]">
                        <span className="tex-[#999] text-[11px] font-normal">{getMessage('tradeInBuyGadget')}</span>
                        <span className="tex-[#333] text-[14px] font-bold">{buyProduct.name}</span>
                      </div>
                    </div>
                    {
                        exchangeProduct !== null && buyProductPrice > exchangeProduct.price ?
                          standartHint :
                          <></>
                    }
                  </div>
                  {
                    exchangeProduct !== null && buyProductPrice < exchangeProduct.price ?
                      priceHigherHint :
                      <>
                        <div className="price-rules-message">{getMessage('priceRules')}</div>
                        <div className="price-rules-message !pt-1">{getMessage('creditPriceRules')}</div>
                      </>
                  }
                </> :
                <></>
            }
          </div>
        </div>
      }

      {
        (buyProduct !== null && exchangeProduct !== null) || (exchangeProduct !== null && selectedMode === 'sell') ?
          <div ref={step3Ref}
            className={`trade-in-holder tradein-callback active from-tablet:!pr-10`}>
            <div className="trade-in-head">
              <div className="trade-in-head__title">
                <span className="trade-in__title-circle">{selectedMode === 'sell' ? '2' : '3'}</span>
                <span
                  className="trade-in__title">{selectedMode === 'sell' ? getMessage('thirdSectionSell') : getMessage('thirdSection')}</span>
              </div>
            </div>
            {
              <TradeInRequest getMessage={getMessage}
                              setRequestFormData={setRequestFormData}
                              requestFormData={requestFormData}
                              setTradeinRequestData={setTradeinRequestData}
                              exchangeProduct={exchangeProduct}
                              buyProduct={buyProduct}
                              selectedMode={selectedMode}
                              sessid={props.sessid}
                              request_url={props.request_url}
                              shopsCities={props.shop_cities}/>
            }
          </div> :
          <></>
      }

      {
        tradeinRequestData ?
          <ModalDialog center={false} type={'tradein'} opened={true} onClose={onCloseModal}>
            <div className="success-send-form" style={{ 'display': 'block' }}>
              {
                tradeinRequestData.hasOwnProperty('success') && tradeinRequestData.success ?
                  <>
                    <div className="row">
                      <div className="modal-title">
                        <span>{getMessage('orderConfirmed')}</span>
                      </div>
                    </div>
                    <div className="row">
                      <span className="modal-text" dangerouslySetInnerHTML={{__html: getMessage('orderHint')}}/>
                    </div>
                    <div className="row row-centered"><span className="ic-success"/></div>
                  </> :
                  <div className="row">
                    <span className="modal-text" dangerouslySetInnerHTML={{__html: getMessage('orderError')}}/>
                  </div>
              }
            </div>
          </ModalDialog> :
          <></>
      }
    </div>
  )
}

export default TradeIn